import React from 'react';
import { navigate } from 'gatsby';
import fetch from 'node-fetch';

import FriendlyOops from '../components/error/friendly-oops';
import CustomAborter from './aborter/custom-aborter';

//
// See https://reactjs.org/docs/error-boundaries.html
// https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
// here https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
// and https://eddiewould.com/2021/28/28/handling-rejected-promises-error-boundary-react/
//
export default class ErrorHandler extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    //
    // Stash unhandled promise rejections in state
    // for error reporting.
    //
    rejectionHandler = (event) => {
        console.log('========================================= GOT ERROR 6 ========================================');
        event.preventDefault();
        this.setState({
            hasError: true,
            error: event.reason ? event.reason : 'unhandled error in EH listener'
        });
    }

    componentDidMount() {
        window.addEventListener('unhandledrejection', (e) => this.rejectionHandler(e));
    }

    componentWillUnmount() {
        window.removeEventListener('unhandledrejection', this.rejectionHandler);
    }

    //
    // During the render phase; no methods here.
    //
    static getDerivedStateFromError(error) {
        console.log('========================================= GOT ERROR 4 ======================================== ');
        return { hasError: true, error: error };
    }

    //
    // Log errors to service.
    //
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            ...(errorInfo) && {errorInfo: errorInfo.componentStack}
          });
          console.log('========================================= GOT ERROR 3 ========================================  error: ' + error?.message + ', info: ' + errorInfo?.componentStack);
        (async () => {
            try {
                await fetch(`${this.props.siteUrl}/api/error-service`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'X-API-KEY': process.env.GATSBY_GVY_KEY
                    },
                    body: JSON.stringify({
                        message: error?.message,
                        errorInfo: errorInfo,
                        userId: this.props.userId, // only if logged in
                        browserInfo: navigator.userAgent,
                        localTime: new Date().toString()
                    }),
                    signal: typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(process.env.GATSBY_TIMEOUT) : CustomAborter.signal(process.env.GATSBY_TIMEOUT)
                });
            } catch (serviceError) { // don't show AbortError
                navigate("/oops", {
                    state: {
                        message: `got ${serviceError?.message} trying to post ${error?.message} to log service`
                    }
                });
            }
        })();
    }

    render() {
        if (this.state.hasError) {
            console.log('========================================= GOT ERROR 2 ======================================== ');
            return <FriendlyOops location={this.props.location} error={this.state.error?.message} errorInfo={this.state.errorInfo}/>
        }
        return this.props.children;
    }

}